import React from 'react';
import { StyleSheet } from 'react-native';

import { CustomIcon } from '@views/shared/CustomIcon';
import { colors } from '@views/shared/styles';

const styles = StyleSheet.create({
  icon: {
    position: 'absolute',
    right: -50,
    bottom: -40,
  },
});

export default function QuestionIcon() {
  return (
    <CustomIcon
      color={colors.grey2}
      name="question"
      size={120}
      style={styles.icon}
    />
  );
}
